import { render, staticRenderFns } from "./TestFormPanel.vue?vue&type=template&id=3cd52c04"
import script from "./TestFormPanel.vue?vue&type=script&lang=js"
export * from "./TestFormPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports